
$(function(){

	// BS carouserl
	$('#carouselOwn').carousel({
	  interval: false,
	});

	// floating inputs
	$('.form-group').each(function(){
	  changeState($(this));
	});

	/*
	 * Inputs blur
	 */
	 $('.form-group').find('input, select, textarea').each(function(){
	  $(this).focus(() => {
	    $(this).parent().addClass('active');
	  }).blur(() => {
	    $(this).parent().removeClass('active');
	  })
	 });

	function changeState(input){
	  var val = input.val();

	  if( val && val.length > 0){
	    input.parents('.form-group').addClass('has-value');
	  } else{
	    input.parents('.form-group').removeClass('has-value');
	  }
	}

	$('.form-control').each(function(){
	    changeState($(this));
	}).on('focusout change', function(){
	    changeState($(this));
	});

	$('#focusRealSearchInput').on('focus click', function(){
	  $('#search-bar-input').focus();
	});


	// slider
	$("#carousel").Cloud9Carousel({
	  buttonLeft: $(".buttons > .left"),
	  buttonRight: $(".buttons > .right"),
	  autoPlay: false,
	  bringToFront: true,
	  autoPlayDelay: 10000,
	  mouseWheel: false,
	  //speed: 5,
	  frontItemClass: "front",
	  onAnimationFinished: function() {
	      removeMarked();
	      markFrontThree();
	    }
	});

	function markFrontThree() {
	  let $carousel = $("#carousel");
	  let $items = $carousel.find(".cloud9-item");
	  let $carouselLen = $items.length;
	  let $front = $carousel.find(".front");

	  markElement($front);

	  switch (true) {
	    case isFirstChild($front):
	      markElement($items.last());
	      markElement($items.eq(1));
	      break;

	    case isLastChild($front):
	      markElement($items.first());
	      markElement($items.eq($front.index() - 1));
	      break;

	    default:
	      markElement($items.eq($front.index() - 1));
	      markElement($items.eq($front.index() + 1));
	  }

	  function isFirstChild(element) {
	    return $(element).index() == 0;
	  }

	  function isLastChild(element) {
	    return $(element).index() == $carouselLen - 1;
	  }

	  function markElement(element) {
	    $(element).addClass("front3");
	  }
	}

	function removeMarked() {
	  $(".front3").removeClass("front3");
	}

	$(".hamburger").click(function(){
		$(this).toggleClass("is-active");
	});

	// smooth scroll to element
	function smoothScroll(id) {
		var id;

		$('html,body').animate({ scrollTop: $(id).offset().top }, 1000, function() {
			window.location.hash = id;
		});
	}

	$('.category-page .choose-category .col-c').on('click', function(e) {
		smoothScroll(this.hash);
		e.preventDefault();
	});

	$('.materials-page .materials .box').on('click', function(e) {
		smoothScroll(this.hash);
		e.preventDefault();
	});


	$('.detail-brand-page .hidden-products a').on('click', function(e) {
		smoothScroll(this.hash);
		e.preventDefault();
	});

	// tablet fadeOut navbar
	if($( window ).width() < 769 ) {
		var previousScroll = 0;
	    $(window).scroll(function(event){
	        var scroll = $(this).scrollTop(),
	            navbar = $(".navbar");

	        if (scroll > previousScroll && scroll > navbar.height()){
	            navbar.filter(':not(:animated)').fadeOut(300);
	        } else {
	            navbar.stop(true).fadeIn(300);
	        }
	       previousScroll = scroll;
		});
	}

	/*
	 * Marek Gogol autoAjax forms
	 */
	$('form.autoAjax').autoAjax();
	
	$('.content-category .page-products .btn').on( 'click', function() {
		
		if($(this).next().hasClass('show')) {
			$(this).removeClass('lessInfo').find('.toggleName').text('Více info');
		} else {
			$(this).addClass('lessInfo').find('.toggleName').text('Méně info');
		}
	});

	$('.alert').delay(3000).fadeOut();

	//  autoHeight for carousel
	var winWidth = $( window ).width();
	var winHeight = $( window ).height();

	homeSlider = $(".home-page header");

	function handleResize() {
	    if (winHeight < 880) {
	      homeSlider.addClass('resizeByHeight');
	    } else {
	      homeSlider.removeClass('resizeByHeight');
	    }
	} 
	handleResize();
	$(window).resize(function(){ handleResize(); });

	// play sound on slider and mategrials click
	function playSound(){
	     var audio = document.getElementById("audioClick");
	     audio.play();
   	}
   	var sliderArrows = $('#carousel .buttons a').find('img'),
   		sliderImages = $('#carousel .image').find('img'),
   		materials = $('.materials .col-c');


   	// play sound on click or hover
   	// sliderImages.on('click', function() {
   	// 	playSound();   		
   	// });
   	// sliderArrows.on('click', function() {
   	// 	playSound();   		
   	// });
   	// materials.on('mouseenter', function() {
   	// 	playSound();   		
   	// });

   	// change background brand categories
   	$('.choose-by-brand .Sodick').on('mouseenter', function	() {
   		$('.choose-by-brand').css('background-image', 'url("../images/cat-sodic.png")');
   	});
   	$('.choose-by-brand .Takumi').on('mouseenter', function	() {
   		$('.choose-by-brand').css('background-image', 'url("../images/cat-takumi.png")');
   	});
   	$('.choose-by-brand .Erowa').on('mouseenter', function	() {
   		$('.choose-by-brand').css('background-image', 'url("../images/cat-erowa.png")');
   	});
   	$('.choose-by-brand .Sisma').on('mouseenter', function	() {
   		$('.choose-by-brand').css('background-image', 'url("../images/cat-sisma.png")');
   	});
   	$('.choose-by-brand .Z-void').on('mouseenter', function	() {
   		$('.choose-by-brand').css('background-image', 'url("../images/cat-z-void.png")');
   	});


});



// WEBPACK FOOTER //
// ./resources/assets/js/main.js